import { useAuth } from "@/contexts/AuthContext";
import SettingsBilling from "@/pages/SettingsBilling";
import { Wrench, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Paywall() {
  const { company, logout } = useAuth();
  const nav = useNavigate();
  const handleLogout = () => { logout(); nav("/login"); };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-blue-50 px-4 py-8">
      <div className="max-w-lg mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-xl bg-blue-600 flex items-center justify-center">
              <Wrench className="w-5 h-5 text-white" />
            </div>
            <span className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>PlumberHQ</span>
          </div>
          <Button variant="outline" onClick={handleLogout} className="h-9 rounded-lg" data-testid="paywall-logout">
            <LogOut className="w-4 h-4 mr-1" /> Log out
          </Button>
        </div>

        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold" style={{ fontFamily: "Outfit" }}>Your trial has ended</h1>
          <p className="text-slate-600 mt-2">
            Subscribe to keep running <b>{company?.name}</b> on PlumberHQ. Your data is safe and ready when you're back.
          </p>
        </div>

        <SettingsBilling compact />

        <p className="text-center text-xs text-slate-400 mt-5">Need help? Contact your PlumberHQ platform admin.</p>
      </div>
    </div>
  );
}
